import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { Sites } from '../data/Detailing';


function CampingRetreatsDetail() {
  const { slug } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [openDay, setOpenDay] = useState(null);



  const site = Sites.find(s => s.slug === slug);

  // Auto-slider effect
  useEffect(() => {
    if (!site) return;

    const interval = setInterval(() => {
      setSelectedImage(prev => (prev + 1) % (site.gallery.length || 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [slug, site]);

  if (!site) {
    return (
      <div style={{
        padding: '60px 20px',
        textAlign: 'center',
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <h2 style={{ color: '#222', fontSize: '28px', marginBottom: '20px' }}>Camping Site Not Found</h2>
        <Link to="/camping" style={{
          backgroundColor: '#f97316',
          color: '#ffffff',
          padding: '10px 20px',
          borderRadius: '6px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '500',
          transition: 'all 0.3s ease'
        }}>
          Back to All Sites
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{site.title} Camping in {site.location} | PlanBanaLo</title>

        <meta
          name="description"
          content={`Book ${site.title} camping in ${site.location}. Enjoy bonfire, trekking, adventure activities and nature stay.`}
        />
      </Helmet>
      <div style={{
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
        backgroundColor: '#ffffff',
        minHeight: '100vh'
      }}>
        {/* Sticky Header with Back Button */}
        <div style={{
          padding: '16px 20px',
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #e5e5e5',
          position: 'sticky',
          top: 70,
          zIndex: 40
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <Link to="/camping" style={{
              color: '#f97316',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.3s ease'
            }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
            >
              ← Back to Camping
            </Link>
          </div>
        </div>

        {/* Main Content */}
        <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
          {/* Hero Image Section with Auto-Slider */}
          <div style={{
            marginBottom: '40px',
            borderRadius: '8px',
            overflow: 'hidden',
            height: '500px',
            backgroundColor: '#000000',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            position: 'relative'
          }}>
            <img
              src={site.gallery[selectedImage]}
              alt={site.title}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'opacity 0.5s ease'
              }}
            />
            {/* Slider Controls */}
            <button
              onClick={() => setSelectedImage(prev => (prev - 1 + site.gallery.length) % site.gallery.length)}
              style={{
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(0,0,0,0.5)',
                color: '#ffffff',
                border: 'none',
                padding: '10px 15px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '18px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                zIndex: 10
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.8)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.5)'}
            >
              &#10094;
            </button>
            <button
              onClick={() => setSelectedImage((prev) => (prev + 1) % site.gallery.length)}
              style={{
                position: 'absolute',
                right: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(0,0,0,0.5)',
                color: '#ffffff',
                border: 'none',
                padding: '10px 15px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '18px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                zIndex: 10
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.8)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0,0,0,0.5)'}
            >
              &#10095;
            </button>
            {/* Image Counter */}
            <div style={{
              position: 'absolute',
              bottom: '15px',
              right: '15px',
              backgroundColor: 'rgba(0,0,0,0.6)',
              color: '#ffffff',
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {selectedImage + 1} / {site.gallery.length}
            </div>
          </div>

          {/* Gallery Thumbnails */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
            gap: '10px',
            marginBottom: '50px'
          }}>
            {site.gallery.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`${site.title} gallery ${idx + 1}`}
                onClick={() => setSelectedImage(idx)}
                style={{
                  height: '90px',
                  width: '100%',
                  objectFit: 'cover',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  border: selectedImage === idx ? '3px solid #f97316' : '2px solid #ddd',
                  transition: 'all 0.3s ease'
                }}
              />
            ))}
          </div>

          {/* Title and Basic Info */}
          <div style={{ marginBottom: '50px' }}>
            <h1 style={{
              fontSize: '32px',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#000000'
            }}>
              {site.title}
            </h1>

            {/* Info Grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '30px',
              marginBottom: '30px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '20px' }}>📍</span>
                <div>
                  <div style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Location</div>
                  <div style={{ fontSize: '16px', color: '#000', fontWeight: '500' }}>{site.location}</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '20px' }}>⭐</span>
                <div>
                  <div style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Rating</div>
                  <div style={{ fontSize: '16px', color: '#000', fontWeight: '500' }}>{site.rating} / 5.0</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '20px' }}>📅</span>
                <div>
                  <div style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Duration</div>
                  <div style={{ fontSize: '16px', color: '#000', fontWeight: '500' }}>{site.duration}</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '20px' }}>👥</span>
                <div>
                  <div style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Capacity</div>
                  <div style={{ fontSize: '16px', color: '#000', fontWeight: '500' }}>{site.guests} Guests</div>
                </div>
              </div>
            </div>

            {/* Description */}
            <p style={{
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#555',
              marginBottom: '30px'
            }}>
              {site.description}
            </p>

            {/* Price and Book Button in Same Row */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              flexWrap: 'wrap'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: '8px'
              }}>
                <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Starting from</span>
                <span style={{ fontSize: '28px', color: '#f97316', fontWeight: '700' }}>{site.price}</span>
                <span style={{ fontSize: '13px', color: '#666', fontWeight: '500' }}>per person</span>
              </div>
              <Link to="/contactus"><button style={{
                backgroundColor: '#f97316',
                color: '#ffffff',
                padding: '12px 32px',
                borderRadius: '6px',
                border: 'none',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#ea6a0d'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#f97316'}
              >
                Book Now
              </button></Link>
            </div>
          </div>

          {/* Itinerary Section */}
          {/* Itinerary Section */}
          <div style={{ marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '600',
              marginBottom: '30px',
              color: '#000000'
            }}>
              Itinerary
            </h2>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {site.itinerary.map((item, idx) => {
                const isOpen = openDay === idx;

                return (
                  <div key={idx} style={{
                    border: isOpen ? '1px solid #f97316' : '1px solid #e5e5e5',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: isOpen ? '#fff7ed' : '#ffffff',
                    boxShadow: isOpen ? '0 6px 20px rgba(249,115,22,0.15)' : 'none',
                    transition: 'all 0.3s ease'
                  }}>

                    {/* Header */}
                    <div
                      onClick={() => setOpenDay(isOpen ? null : idx)}
                      style={{
                        padding: '18px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{
                          width: '34px',
                          height: '34px',
                          backgroundColor: '#f97316',
                          color: '#fff',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '13px',
                          fontWeight: '600'
                        }}>
                          {item.day}
                        </span>

                        <h3 style={{
                          margin: 0,
                          fontSize: '17px',
                          fontWeight: '600'
                        }}>
                          {item.title}
                        </h3>
                      </div>

                      <span style={{
                        fontSize: '20px',
                        color: '#f97316',
                        fontWeight: '700'
                      }}>
                        {isOpen ? "−" : "+"}
                      </span>
                    </div>

                    {/* Expand Content */}
                    {isOpen && (
                      <div style={{
                        padding: '0 20px 20px 66px',
                        color: '#555',
                        lineHeight: '1.6',
                        fontSize: '15px'
                      }}>
                        {item.description}
                      </div>
                    )}

                  </div>
                );
              })}
            </div>
          </div>

          {/* Amenities Section */}
          <div style={{ marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '600',
              marginBottom: '30px',
              color: '#000000'
            }}>
              Amenities
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: '15px'
            }}>
              {site.amenities.map((amenity, idx) => (
                <div key={idx} style={{
                  padding: '15px 20px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '6px',
                  border: '1px solid #e5e5e5',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontSize: '15px',
                  color: '#333',
                  fontWeight: '500'
                }}>
                  <span style={{ fontSize: '18px' }}>✓</span>
                  {amenity}
                </div>
              ))}
            </div>
          </div>

          {/* Reviews Section */}
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '600',
              marginBottom: '30px',
              color: '#000000'
            }}>
              Guest Reviews
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {site.reviews.map((review, idx) => (
                <div key={idx} style={{
                  padding: '20px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '8px',
                  border: '1px solid #e5e5e5'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#000000',
                      margin: 0
                    }}>
                      {review.name}
                    </h4>
                    <span style={{ color: '#f97316', fontSize: '14px', fontWeight: '600' }}>
                      {'⭐ '.repeat(review.rating)} {review.rating}/5
                    </span>
                  </div>
                  <p style={{
                    fontSize: '15px',
                    lineHeight: '1.5',
                    color: '#555',
                    margin: 0
                  }}>
                    {review.comment}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default CampingRetreatsDetail;


